import $store from "@/state/store"
import { BaseAbstractService } from "@/services/base.abstract.service";
export class AbstractService extends BaseAbstractService {
  constructor() {
    super();
    if (this.constructor === AbstractService) {
      throw new Error("FYI: Instance of Abstract class cannot be instantiated");
    }
  }

  static get baseUrl() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }

  static get entity() {
    throw new Error("entity getter not defined");
  }

  static get baseHeader() {
    return {
      "np-app-id": process.env.VUE_APP_ID,
      "np-user-id": $store.state.auth.currentUser.userId,
      "np-location-id": $store.state.auth.currentLocation,
      "np-merchant-id": $store.state.auth.currentUser.merchantId
    };
  }
}
